// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Operator } from './Operator';
import {
    OperatorFromJSON,
    OperatorFromJSONTyped,
    OperatorToJSON,
    OperatorToJSONTyped,
} from './Operator';
import type { VehicleMode } from './VehicleMode';
import {
    VehicleModeFromJSON,
    VehicleModeFromJSONTyped,
    VehicleModeToJSON,
    VehicleModeToJSONTyped,
} from './VehicleMode';

/**
 * A passenger carrying Service (phyisical public transport vehicle) provided and operated by a certain Operator allocated to a concrete ServiceJourney on an `OperatingDay`.<br>See SBB specific transport-modes: [v580 de:Verkehrsmittelkategorien (aka Transmodel or OJP/Siri `VehicleMode`)](https://github.com/SchweizerischeBundesbahnen/journey-service/blob/master/business/TransportMode.md).
 * @export
 * @interface ServiceProduct
 */
export interface ServiceProduct {
    /**
     * Complete product name and may consist of {`vehicleSubModeShortName`, `line`, `number`}. (Refers to Transmodel `Line::name/::id`.)
     * @type {string}
     * @memberof ServiceProduct
     */
    name: string;
    /**
     * Principally same as related `name` but adapted by SBB Business Rules to display for passengers.
     * @type {string}
     * @memberof ServiceProduct
     */
    nameFormatted: string;
    /**
     * Usually referring to a specific commercial PT route (where direction might be either way), shown on vehicle displays. If this value is missing, it is probably a _single-journey (de:Einzelfahrt)_. (Refers to Transmodel `Line::id`.)
     * @type {string}
     * @memberof ServiceProduct
     */
    line?: string;
    /**
     * External line-reference like SLNID (source INFO+) or TU specific value (for e.g. provided by Postauto AG), relates to `line`.
     * @type {string}
     * @memberof ServiceProduct
     */
    lineId?: string;
    /**
     * 
     * @type {VehicleMode}
     * @memberof ServiceProduct
     */
    vehicleMode: VehicleMode;
    /**
     * Unique per `OperatingDay` (CH day-change at 04:00 !) and name (where 'IC 1' can run several times per day in either of opposite directions). For passenger display use `numberFormatted` instead! (Aka Transmodel: `TrainNumber`)
     * @type {string}
     * @memberof ServiceProduct
     */
    number?: string;
    /**
     * @Deprecated Same as `number` or suppressed by BR to not confuse passengers (with internal technical values).
     * @type {string}
     * @memberof ServiceProduct
     * @deprecated
     */
    numberFormatted?: string;
    /**
     * 
     * @type {Operator}
     * @memberof ServiceProduct
     */
    operator?: Operator;
    /**
     * Defines the first ScheduledStop::routeIndex where this product is valid on a Line, null if unknown.
     * @type {number}
     * @memberof ServiceProduct
     */
    routeIndexFrom?: number;
    /**
     * Defines the last ScheduledStop::routeIndex where this product is valid on a Line, null if unknown
     * @type {number}
     * @memberof ServiceProduct
     */
    routeIndexTo?: number;
    /**
     * Icon-identifier to represent the `ServiceProduct` specific submode (for e.g. the symbol for an 'EC 1'). See [SBB Corporate-Identity catalog (CDN, aka FIGMA Icons)](https://www.figma.com/file/UQBd7cHKav0hr9oXYp7opJ/SBB-Icons?node-id=395%3A2952&t=ad26LgREBbTANSK5-1)
     * @type {string}
     * @memberof ServiceProduct
     */
    corporateIdentityIcon?: string;
}

/**
 * Check if a given object implements the ServiceProduct interface.
 */
export function instanceOfServiceProduct(value: object): value is ServiceProduct {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('nameFormatted' in value) || value['nameFormatted'] === undefined) return false;
    if (!('vehicleMode' in value) || value['vehicleMode'] === undefined) return false;
    return true;
}

export function ServiceProductFromJSON(json: any): ServiceProduct {
    return ServiceProductFromJSONTyped(json, false);
}

export function ServiceProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceProduct {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'nameFormatted': json['nameFormatted'],
        'line': json['line'] == null ? undefined : json['line'],
        'lineId': json['lineId'] == null ? undefined : json['lineId'],
        'vehicleMode': VehicleModeFromJSON(json['vehicleMode']),
        'number': json['number'] == null ? undefined : json['number'],
        'numberFormatted': json['numberFormatted'] == null ? undefined : json['numberFormatted'],
        'operator': json['operator'] == null ? undefined : OperatorFromJSON(json['operator']),
        'routeIndexFrom': json['routeIndexFrom'] == null ? undefined : json['routeIndexFrom'],
        'routeIndexTo': json['routeIndexTo'] == null ? undefined : json['routeIndexTo'],
        'corporateIdentityIcon': json['corporateIdentityIcon'] == null ? undefined : json['corporateIdentityIcon'],
    };
}

  export function ServiceProductToJSON(json: any): ServiceProduct {
      return ServiceProductToJSONTyped(json, false);
  }

  export function ServiceProductToJSONTyped(value?: ServiceProduct | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'nameFormatted': value['nameFormatted'],
        'line': value['line'],
        'lineId': value['lineId'],
        'vehicleMode': VehicleModeToJSON(value['vehicleMode']),
        'number': value['number'],
        'numberFormatted': value['numberFormatted'],
        'operator': OperatorToJSON(value['operator']),
        'routeIndexFrom': value['routeIndexFrom'],
        'routeIndexTo': value['routeIndexTo'],
        'corporateIdentityIcon': value['corporateIdentityIcon'],
    };
}

